import { v4 as uuidv4 } from 'uuid';

export class PaymentService {
    private postPaymentUrl : string  = "";
    private attachToCustomerUrl : string  = "";

    constructor(){
        this.postPaymentUrl = (process.env.REACT_APP_BASE_API_URL ?? "") + (process.env.REACT_APP_API_QUOTE_POSTPAYMENT ?? "");
        this.attachToCustomerUrl = (process.env.REACT_APP_BASE_API_URL ?? "") + (process.env.REACT_APP_API_INTEGRATION_STRIPE_ATTACH_TO_CUSTOMER ?? "");
    }

    async savePayment(policyType: "QUOTE" | "MONTHLY" | "RENEWAL",
        policyNumber: string, 
        paymentType: "CC",
        amount: number, 
        transactionId: string, 
        token: string,
        ccLastFour: string,
        ccExpirationDate: string) : Promise<Response> {
            var self = this;

            switch(policyType){
                case "QUOTE":
                    return self.saveQuotePayment(policyNumber, paymentType, amount, transactionId,token, ccLastFour, ccExpirationDate);
                case "MONTHLY":
                    throw "Unsupported policy type";
                case "RENEWAL":
                    throw "Unsupported policy type";
                default:
                    throw "Unsupported policy type";
            }
        }


        private async saveQuotePayment(policyNumber: string, 
            paymentType: "CC",
            amount: number, 
            transactionId: string, 
            token: string,
            ccLastFour: string,
            ccExpirationDate: string) {        
                
            var jsonRequest = {
                guid: uuidv4(),
                policyNumber: policyNumber,
                totalPaidAmt : amount,
                transactionId: transactionId,
                paymentType: paymentType,
                userName: "ford-ui-api"
            };
    
            return fetch(this.postPaymentUrl,
            {
                mode: "cors",
                method: "POST",
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Content-Type": "application/json",
                    "pace-api-key": (process.env.REACT_APP_API_KEY ?? "")
                },
                body: JSON.stringify(jsonRequest)
            });
        }

        
    async attachToCustomer(customerId:string, paymentMethodId:string, rateCycle:string) {        
            
        var jsonRequest = {
            customerId: customerId,
            paymentMethodId: paymentMethodId,
            rateCycle:rateCycle
        };

        console.log({attach_to_customer_request: jsonRequest});
        console.log({attachToCustomerUrl:this.attachToCustomerUrl});
        return fetch(this.attachToCustomerUrl,
        {
            mode: "cors",
            method: "PATCH",
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/json",
                "pace-api-key": (process.env.REACT_APP_API_KEY ?? "")
            },
            body: JSON.stringify(jsonRequest)
        });
    }
}
